import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function MBAAIToolsWorkshop2025() {

    const images = [
        "1000373661.jpg ",
        "1000374658.jpg ",
        "1000373658.jpg",
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">

                                    <h2 className="pb-2">
                                        Workshop on AI Tools for MBA Students – Sponsored by Infosys & Magic Bus Foundation
                                    </h2>

                                    <p>
                                        MBA department has organized a <strong>12-day workshop on AI tools</strong> – conducted by 
                                        <strong> Magic Bus Foundation</strong> and <strong>sponsored by Infosys</strong> under the CSR program.
                                        <br /><br />
                                        In twelve days they would cover different AI topics that are relevant to business.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/mba-ai-tools-workshop-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/mba-ai-tools-workshop-2025/${img}`}
                                                            loading="lazy"
                                                            alt={`AI Tools Workshop Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1 sixteen-nine"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default MBAAIToolsWorkshop2025;
